export { QAFooter } from "./QAFooter";
export { QAItem } from "./QAItem";
export { QATitle } from "./QATitle";
export { QAWrapper } from "./QAWrapper";
